const firebaseConfig = {
  apiKey: "AIzaSyBUs85Caunu7AR-n15hICrQY5J3-RpmAng",
  authDomain: "express-fruits.firebaseapp.com",
  projectId: "express-fruits",
  storageBucket: "express-fruits.appspot.com",
  messagingSenderId: "453125732406",
  appId: "1:453125732406:web:dd56e4efa3403c90b7c097",
};
export default firebaseConfig;
